<template>
  <Header />
  <ServiceProperty />
  <Service />
  <ServiceIcons />
  <Footer />
</template>
<script>
import Service from "@/components/Service/InsightsReports/Service.vue";
import ServiceIcons from "@/components/Service/InsightsReports/ServiceIcons.vue";
import ServiceProperty from "@/components/Service/InsightsReports/ServiceProperty.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Service,
    ServiceIcons,
    ServiceProperty,
    Header,
    Footer,
  },
};
</script>
